import React, { useMemo, useState } from 'react';
import { AuraChatContext } from './context';

type Props = {
  canToggleAuraChat: boolean;
  payerDigitalTwinsProjectId?: number;
  children: React.ReactNode;
};

export const AuraChatContainer = ({ canToggleAuraChat, payerDigitalTwinsProjectId, children }: React.PropsWithChildren<Props>) => {
  const [auraChatStatus, setAuraChatStatus] = useState<boolean>(false);

  const ctx = useMemo(() => ({
    canToggleAuraChat,
    auraChatStatus,
    setAuraChatStatus,
    payerDigitalTwinsProjectId,
  }), [canToggleAuraChat, auraChatStatus, payerDigitalTwinsProjectId]);

  return (
    <AuraChatContext.Provider value={ctx}>
      {children}
    </AuraChatContext.Provider>
  );
};
